import { CurrentLanguage, Language } from './Language';

export interface SiteConfig {
    domain: string;
    'phone.support': string;
    'phone.office_hours': string;
    locale: string;
    accepted_locales: string[];
    currency: string;
}

export type SiteConfigKeys = keyof SiteConfig;

export type Capability =
    | 'about_imprint'
    | 'can_display_resource_center_link'
    | 'can_display_featured_partners_link';

export type SocialMediaHandle = 'twitter' | 'facebook';

export class Site {
    siteConfig: SiteConfig;

    constructor(siteConfig: SiteConfig) {
        this.siteConfig = siteConfig;
    }

    get<K extends SiteConfigKeys>(key: K) {
        return this.siteConfig[key];
    }

    getDomain() {
        return this.siteConfig.domain;
    }

    getLanguage() {
        return new CurrentLanguage(this.siteConfig.locale);
    }

    getLanguageCode() {
        return this.getLanguage().getLanguageCode();
    }

    getSwitchableLanguages() {
        const currentLocale = this.siteConfig.locale;
        const acceptedLocales = this.siteConfig.accepted_locales || [];
        const languages: Array<CurrentLanguage | Language> = [];

        if (acceptedLocales.length > 1) {
            for (const locale of acceptedLocales) {
                languages.push(
                    locale === currentLocale ? new CurrentLanguage(locale) : new Language(locale)
                );
            }
        }

        languages.sort(a => {
            return a.isCurrent() ? -1 : 1;
        });

        return languages;
    }

    hasCapability(name: Capability) {
        return this.siteConfig[`capabilities.${name}` as keyof SiteConfig];
    }

    getSocialMediaHandleFor(name: SocialMediaHandle) {
        const social = this.siteConfig[`socialmedia.${name}` as keyof SiteConfig];
        if (!social) throw new Error(`Cannot find socialmedia.${name}`);
        return social;
    }
}
